import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { map } from 'rxjs/operators';

import { environment } from "@environments/environment";

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';
import { ResourceService } from '../index.service';
import { Hospital } from '../../interfaces/hospital.interface';
import { Payor } from '../../interfaces/payor.interface';
import { Consultant } from '../../interfaces/consultant.interface';
import { AppConstants } from '../../appConstants';
import { Observable } from 'rxjs';
import { PortalConfigurationService } from '../portal-configuration/portal-configuration.service';

@Injectable()
export class DatabaseResourcesService {

  backURL = environment.BACKURL;
  RESOURCES_ON_SYNC = environment.RESOURCES_ON_SYNC;
  allHospitals: Array<Hospital>
  activeHospitals: Array<Hospital>
  payors: Array<Payor>
  assistants: Array<Consultant>
  consultant: Consultant;
  departments = [];
  subdepartments = [];
  configuration;
  isActived: boolean = true;
  logo;
  name;
  address;
  email;
  phoneNumber;
  loading;

  private themeWrapper = document.querySelector('body');

  constructor(public http: HttpClient, public _resourceService: ResourceService,
    public translate: TranslateService, public _portalConfigurationService: PortalConfigurationService) {
    if (environment.RESOURCES_ON_DATABASE && !environment.RESOURCES_ON_SYNC) {
      this.getAllResources();
    }


  }
  haveAllResources() {
    if (!this.allHospitals) {
      return false;
    }
    return true;
  }

  setConfiguration(configuration) {
    this.isActived = configuration.actived;
    this.logo = configuration.logo;
    this.themeWrapper.style.setProperty('--main-color', configuration.mainColor);
    this.themeWrapper.style.setProperty('--secondary-color', configuration.secondaryColor);
    this.name = configuration.name;
    this.address = configuration.address;
    this.phoneNumber = configuration.phoneNumber;
    this.email = configuration.email;
    this.loading = false;
  }

  updateConfiguration(ppconfiguration) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/updateconfiguration';
    return this.http.post(url, ppconfiguration);
  }

  upoloadLogoFile(fileContents) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/upoloadLogoFile';
    return this.http.post(url, { fileContents })
  }

  getConfiguration() {
    let url = this.backURL + 'rest/databaseresource/configuration';
    return this.http.get(url);
  }

  getAndSetConfiguration() {
    this.loading = true;
    this.getConfiguration().subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.configuration = response.result[0];
        this.setConfiguration(this.configuration);
      }
    });
  }

  getAllResources() {
    this.getActiveHospitals().subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.activeHospitals = response.result;
        if (this.activeHospitals.length == 1) {
          let params = {
            hospitalId: this.activeHospitals[0].id,
          };
          this.getDepartments(params)
            .subscribe(data => {
              let response = data as ResponseDataBase;
              this.departments = response.result;
              this.loading = false;
            });
        }
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this.loading = false;
    });
    this.getAllHospitals().subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.allHospitals = response.result;
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this.loading = false;
    });
    this.getAllPayors().subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.payors = response.result;
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this.loading = false;
    });
    this.getAllAssistants().subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.assistants = response.result;
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this.loading = false;
    });
  }

  getActiveHospitals() {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/activehospitals';
    return this.http.get(url);
  }

  getAllHospitals() {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/allhospitals';
    return this.http.get(url);
  }

  addHospital(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/addhospital';
    return this.http.post(url, params)
  }

  updateHospital(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/updatehospital';
    return this.http.post(url, params)
  }

  deleteHospital(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/deletehospital';
    return this.http.get(url, { params: params })
  }

  getDepartments(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/departments';
    return this.http.get(url, { params: params })
  }

  addDepartment(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/adddepartment';
    return this.http.post(url, params)
  }

  updateDepartment(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/updatedepartment';
    return this.http.post(url, params)
  }

  deleteDepartment(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/deletedepartment';
    return this.http.get(url, { params: params })
  }

  getAllPayors() {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/allpayors';
    return this.http.get(url);
  }

  addPayor(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/addpayor';
    return this.http.post(url, params)
  }

  updatePayor(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/updatepayor';
    return this.http.post(url, params)
  }

  deletePayor(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/deletepayor';
    return this.http.get(url, { params: params })
  }

  getAllAssistants() {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/allassistants';
    return this.http.get(url);
  }


  getSubdepartments(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/subdepartments';
    return this.http.get(url, { params: params })
  }

  addSubdepartment(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/addsubdepartment';
    return this.http.post(url, params)
  }

  updateSubdepartment(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/updatesubdepartment';
    return this.http.post(url, params)
  }

  deleteSubdepartment(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/deletesubdepartment';
    return this.http.get(url, { params: params })
  }

  getConsultantsFromUnit(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/consultantsfromunit';
    return this.http.get(url, { params: params })
  }

  getConsultant(email) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/consultant';
    return this.http.get(url, { params: email })
  }

  getConsultantAppointments(consultantId) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/getconsultantappointments';
    return this.http.get(url, { params: consultantId })
  }

  addConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/addconsultant';
    return this.http.post(url, params)
  }

  updateConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/updateconsultant';
    return this.http.post(url, params)
  }

  deleteConsultantFromUnit(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/deleteconsultantfromunit';
    return this.http.get(url, { params: params })
  }

  assignHospitalToConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/assignhospitaltoconsultant';
    return this.http.post(url, params)
  }

  removeConsultantFromHospital(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/removeconsultantfromhospital';
    return this.http.post(url, params)
  }

  assignDepartmentToConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/assigndepartmenttoconsultant';
    return this.http.post(url, params)
  }

  removeDepartmentFromConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/removedepartmentfromconsultant';
    return this.http.post(url, params)
  }

  assignSubdepartmentToConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/assignsubdepartmenttoconsultant';
    return this.http.post(url, params)
  }

  removeSubdepartmentFromConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/removesubdepartmentfromconsultant';
    return this.http.post(url, params)
  }

  assignUnitToConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/assignunittoconsultant';
    return this.http.post(url, params)
  }

  assignPayorToConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/assignpayortoconsultant';
    return this.http.post(url, params)
  }

  removePayorFromConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/removepayorfromconsultant';
    return this.http.post(url, params)
  }

  assignAssistantToConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/assignassistanttoconsultant';
    return this.http.post(url, params)
  }

  removeAssistantFromConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/removeassistantfromconsultant';
    return this.http.post(url, params)
  }

  deleteConsultant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/deleteconsultant';
    return this.http.get(url, { params: params })
  }

  searchConsultants(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/searchconsultants';
    return this.http.get(url, { params: params })
  }

  searchConsultantsByAssistant(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/searchconsultants';
    return this.http.get(url, { params: params })
  }

  saveTime(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/updateconsultantschedule';
    return this.http.post(url, params)
  }

  deleteScheduleTime(params) {
    this.loading = true;
    let url = this.backURL + 'rest/databaseresource/deletescheduletime';
    return this.http.get(url, { params: params })
  }

  searchDatabaseFreeSlots(params) {
    let url = this.backURL + 'rest/databaseresource/searchdatabasefreeslots';
    return this.http.get(url, { params: params })
  }

}
